import { useRef } from 'react';

const useLatestRef = <T>(values: T) => {
  const ref = useRef(values);
  ref.current = values;
  return ref;
};

export default useLatestRef;
